import { FC } from 'react';

const FolderIcon: FC = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
    <path
      d="M7 15C7 13.07 8.57 11.5 10.5 11.5H20L23.5 15H41.5C43.43 15 45 16.57 45 18.5V38C45 39.93 43.43 41.5 41.5 41.5H10.5C8.57 41.5 7 39.93 7 38V15Z"
      fill="currentColor"
      opacity="0.28"
    />
    <path
      d="M7 18.5C7 16.57 8.57 15 10.5 15H41.5C43.43 15 45 16.57 45 18.5V38C45 39.93 43.43 41.5 41.5 41.5H10.5C8.57 41.5 7 39.93 7 38V18.5Z"
      fill="currentColor"
    />
  </svg>
);

export default FolderIcon;
